import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './Toggle.scss'

const Toggle = ({
  id,
  checked,
  onChange,
  isToggleWithLabel = false,
  disabled = false,
  size = 'medium',
  className,
  label,
  disableOpacity = false,
  ...rest
}) => {
  const toggleClasses = classNames('toggle-switch', {
    [`toggle-switch--${size}`]: size,
    [className]: className,
    'toggle-switch--disable-opacity': disableOpacity && disabled,
  })

  return (
    <div
      className={classNames('d-flex ', {
        'align-items-center': isToggleWithLabel,
      })}>
      <div className={toggleClasses}>
        <input
          type='checkbox'
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
        <label htmlFor={id} className='toggle-switch__visual'></label>
      </div>
      {label && (
        <label htmlFor={id} className='toggle-switch__label mb-0 ml-3'>
          {label}
        </label>
      )}
    </div>
  )
}

Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  label: PropTypes.string,
}

export default Toggle
